import { TUser, IAuthenticatedUser } from '../../types/user';

export const hasEmail = (userForCheck: TUser): userForCheck is IAuthenticatedUser => {
  return 'email' in userForCheck;
};
